/* eslint-disable react-hooks/exhaustive-deps */
import { ApButtonSecondary } from '@alixpartners/ui-components';
import BreakDownFilters from 'SpendController/Components/BreakDownFilters/BreakDownFilters';
import {
	ColumnContainer,
	Container,
	GridContainer,
	GridItem,
	Header,
	HeaderSpan,
	RefreshSpan,
	TableFilterHeader,
} from 'SpendController/Components/Components.styles';
import LoadingSpinner from 'SpendController/Components/LoadingSpinner/LoadingSpinner';
import Summary from 'SpendController/Components/Summary/Summary';
import TableView from 'SpendController/Components/TableView';
import { TableWrapper } from 'SpendController/Components/TableView/TableView.style';
import { useSpendControllerFiltersContext } from 'SpendController/Contexts/SpendControllerFiltersProvider';
import {
	GL_HEADER,
	GL_REFRESH_HEADER,
	extractSelectedArrays,
	WORKSHOP_KPI_DATA,
	combineDataWorkShopKpiData,
} from 'SpendController/utils';
import React, { useEffect, useState } from 'react';
import { getWorkshopSummaryKpis } from 'utils/apiRequests';

const healthBars = ['WorkShop Health Bar'];
function WorkShop() {
	const [workShopBaselineKpiData, setWorkShopBaselineKpiData] = useState(
		WORKSHOP_KPI_DATA
	);
	const [isLoading, setIsLoading] = useState(false);
	const [reFresh, setrefresh] = useState(false);
	const [gridApi, setGridApi] = useState(null);

	const selectedSpendType = ['MACRO'];
	const {
		filters,
		workShopColumnDefs,
		filterModelData,
		refresh,
		setRefresh,
		uploadRefresh,
		handleSpendControllerFilters,
		setSpendType,
		setUploadRefresh,
	} = useSpendControllerFiltersContext();
	useEffect(
		() => {
			handleKpiData(filters, true);
		},
		[filters]
	);
	useEffect(
		() => {
			refresh && handleKpiData(filters);
		},
		[refresh]
	);
	useEffect(
		() => {
			uploadRefresh &&
				(() => {
					handleSpendControllerFilters();
					handleKpiData(filters);
				})();
		},
		[uploadRefresh]
	);
	useEffect(() => {
		setSpendType(selectedSpendType);
	}, []);
	const handleKpiData = async (filters, realTime = false) => {
		const tempFilters = extractSelectedArrays(filters);
		const microFilters = Object.assign({}, tempFilters);
		microFilters.tailSpendType = ['MACRO'];
		realTime && setIsLoading(true);
		const workShopBaselineKpiDataResponse = await getWorkshopSummaryKpis(
			microFilters
		);

		const tempPreWorkShopBaselineKpiData = combineDataWorkShopKpiData(
			workShopBaselineKpiDataResponse,
			workShopBaselineKpiData.data
		);
		setWorkShopBaselineKpiData({
			...workShopBaselineKpiData,
			data: tempPreWorkShopBaselineKpiData,
		});
		realTime && setIsLoading(false);
		setRefresh(false);
	};
	return (
		<Container>
			<LoadingSpinner visible={isLoading} message={`Loading`} />
			<div style={{ display: 'flex', justifyContent: 'space-between' }}>
				<GridContainer style={{ width: '180px' }}>
					{healthBars.map((name, index) => (
						<GridItem
							key={index}
							selected={true}
							onClick={() => console.log(index)}
						>
							{name}
						</GridItem>
					))}
				</GridContainer>
				<ApButtonSecondary
					onClick={() => {
						setUploadRefresh(state => !state);
						setrefresh(state => !state);
					}}
					small
					style={{ margin: '1%' }}
				>
					Refresh/Save
				</ApButtonSecondary>
			</div>
			<div style={{ padding: '0px 0 0 10px' }}>
				<Summary {...workShopBaselineKpiData} />
			</div>

			<ColumnContainer>
				<Header>
					<RefreshSpan>{GL_REFRESH_HEADER}</RefreshSpan>
				</Header>
				<TableFilterHeader>
					<HeaderSpan>{GL_HEADER}</HeaderSpan>
					<BreakDownFilters gridApi={gridApi} />
				</TableFilterHeader>
				<TableWrapper n={6}>
					<TableView
						data={workShopColumnDefs}
						columnDefs={workShopColumnDefs.headers}
						filters={filterModelData}
						mainfilters={filters}
						handleCall={handleKpiData}
						selectedSpendType={selectedSpendType}
						refresh={reFresh}
						gridApi={gridApi}
						setGridApi={setGridApi}
					/>
				</TableWrapper>
			</ColumnContainer>
		</Container>
	);
}

export default WorkShop;
